<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="``"
    width="1000px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="details-view air-markup"
  >
    <div class="tabs-container">
      <el-tabs
        ref="tabs"
        v-model="activeTabName"
        type="card"
        style="width:100%;"
      >
        <el-tab-pane v-show="showMarkup" :label="$t('Pricing.Markup')" name="markup">
          <air-approve-settings
            ref="airApproveSettings"
            :config-util="configUtil"
            :is-h-q-manager="isHQManager"
            @close="onCancel"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>
import AirApproveSettings from '@/views/cargo/v0/Price/PriceAir/components/airApproveSettings.vue'

export default {
  name: 'AirSettingsPopup',
  components: { AirApproveSettings },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    configUtil: {
      type: Object,
      default: () => {
      }
    },
    isHQManager: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      fullscreenLoading: null,
      markupLocked: false,
      activeTabName: 'markup',
      showMarkup: false,
      showOvertimeApprove: false,
      showLbl: false
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  methods: {
    init() {
      this.showMarkup = this.configUtil.markupLocked
      // this.showOvertimeApprove = this.configUtil.needCheckApprove
      this.showLbl = this.activeTabName === 'markup'
      this.$nextTick(() => {
        this.$refs['airApproveSettings'].init()
      })
    },
    onCancel() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
